import modalStyles from 'styles/base/modals.module.scss';

export const fadeAnimation = {
    fadeInClassName: modalStyles.fadeIn,
    fadeOutClassName: modalStyles.fadeOut,
    duration: Number(modalStyles.animationDuration),
};
